/**
 * Local, opt-in snake_case -> camelCase deep transform for the payment/
 * subscription/feature services. The global response transformer
 * (response-transformer.ts) was intentionally disabled app-wide -- most
 * services now consume snake_case directly -- but the payment module's
 * TypeScript types (SubscriptionPlan, UserSubscription, Feature, ...) were
 * written against camelCase and are used that way across PlanManagement,
 * SubscriptionManagement, Pricing, and Checkout. Rather than reviving the
 * global transform (which the rest of the app now relies on staying inert)
 * or rewriting every payment type/component to snake_case, this module
 * applies the conversion only at the edge of these specific services.
 */

function snakeToCamelKey(key: string): string {
  return key.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase());
}

export function snakeToCamelDeep<T = any>(value: any): T {
  if (Array.isArray(value)) {
    return value.map((item) => snakeToCamelDeep(item)) as any;
  }
  if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
    const result: any = {};
    for (const key of Object.keys(value)) {
      result[snakeToCamelKey(key)] = snakeToCamelDeep(value[key]);
    }
    return result;
  }
  return value;
}
